import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
// import Navbar from './Navbar'
import { format } from 'date-fns';
import { Button } from 'react-bootstrap';

const Where = () => {
  const apiUrl = process.env.REACT_APP_MAP_URL;
  const [curNow, setNow] = useState(null);
  const [refreshInterval, setRefreshInterval] = useState(500000);
  const [streetData, setStreetData] = useState(null);
  const [gpsData, setGpsData] = useState(null);
  const [errors, setErrors] = useState({});

  // Home panel
  // auto-refresh
  const refreshWhere = () => {
    // update time
    try {
      setNow(format(new Date().toLocaleString(), 'eee HH:mm:ss'));
    } catch (error) {

    }
  }

  const [lat, setLat] = useState();
  const [lon, setLon] = useState();
  const [street, setStreet] = useState();
  const [zip, setZip] = useState();

  useEffect(() => {
    // fetch(`http://45.79.209.183:2052/reverse?format=jsonv2&lat=41.28253145&lon=-72.34972853160502`)
    //   .then(response => response.json())
    //   .then(data => setData(data))
    //   .catch(error => console.error(error));

    // if (refreshInterval && refreshInterval > 0) {
    //   const interval = setInterval(refreshHome, refreshInterval);
    //   return () => clearInterval(interval);
    // }
  },);

  const handleLatChange = (event) => {
    setLat(event.target.value);
  };
  const handleLonChange = (event) => {
    setLon(event.target.value);
  };
  function getGPS(event) {
    // event.preventDefault(); http://osm.org/copyright","osm_type":"node","osm_id":7083904697,"lat":"27.1317096","lon":"-81.331428","category":"place","type":"house","place_rank":30,"importance":0.00000999999999995449,"addresstype":"place","name":"","display_name":"69, 
    // const formData = new FormData(event);
    // const lat = formData.get("lat");
    // const lon = formData.get("lon");
    alert(`GPS. lat=${lat}&lon=${lon}`);
    fetch(`${apiUrl}reverse?format=jsonv2&lat=${lat}&lon=${lon}`)
      .then(response => response.json())
      .then(data => setGpsData(data))
      .catch(error => console.error(error));
  };

  const handleStreetChange = (event) => {
    setStreet(event.target.value);
  };
  const handleZipChange = (event) => {
    setZip(event.target.value);
  };
  function getStreet(event) {
    alert(`Street. street=${street}&zip=${zip}`);
    fetch(`${apiUrl}search?addressdetails=1&format=jsonv2&street=${street}&postcode=${zip}`)
      .then(response => response.json())
      .then(data => setStreetData(data))
      .catch(error => console.error(error));
  };

  return (
    <div className="container topLine3">
      <div className="row">
        <div className="col-sm-12">
          <h1>Where </h1>

        </div>
      </div>
      <div className="container">
        <Form>
          <div className="row">
            <span className="col-sm-4">
              Type in a street and zip. You should get the full address back and the GPS.
            </span>
            <span className="col-sm-4">

              <Form.Group className="mb-3" controlId="street">
                <Form.Label>Street</Form.Label>
                <Form.Control placeholder="123 street name road" value={street} onChange={handleStreetChange} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="zip">
                <Form.Label>Postal (Zip)</Form.Label>
                <Form.Control placeholder="00000" value={zip} onChange={handleZipChange} />
              </Form.Group>
              <Button onClick={() => getStreet()}>Find Street</Button>

            </span>
            <span className="col-sm-4">
              {streetData ?

                <span className="col-sm-4">
                  Street
                  Address(es) found using Street and Zip
                  {
                    streetData.map((item, index) => (
                      <div className="row">
                        <span className="col-sm-12 d-flex  align-items-center justify-content-center ">
                          <span className="stattext">{item.display_name}</span>
                          Lat: {item.lat} <br></br>
                          Lon: {item.lon}
                        </span>
                        <hr></hr>
                      </div>
                    ))}
                </span>
                : <span className="col-sm-4">Nada Yet</span>}
            </span>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <hr></hr>
            </div>
          </div>
          <div className="row">
            <span className="col-sm-4">
              Use this to check a longitude and latitude.
            </span>
            <span className="col-sm-4">
              <Form.Group className="mb-3" controlId="lat">
                <Form.Label>Latitude {lat}</Form.Label>
                <Form.Control value={lat} onChange={handleLatChange} placeholder="0.0" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="lon">
                <Form.Label>Longitude {lon}</Form.Label>
                <Form.Control value={lon} onChange={handleLonChange} placeholder="0.0" />
              </Form.Group>
              <Button onClick={() => getGPS()}>Show Address</Button>
            </span>
            {gpsData ?
              <span className="col-sm-4">
                Address found using GPS
                <div className="row">
                  <span className="col-sm-12 d-flex  align-items-center justify-content-center ">
                    <h4>{gpsData.display_name}</h4>
                    Lat: {gpsData.lat} <br></br>
                    Lon: {gpsData.lon}
                  </span>
                </div>
              </span>
              : <span className="col-sm-4">Nada Yet</span>}
          </div>
          <div className="row">
            <div className="col-sm-12">
              <hr></hr>
            </div>
          </div>
          <div className="row">
            <span className="col-sm-6">
              <div className="padit align-items-center justify-content-center border border-info detailhdr">
                Test the GPS. This is a private GPS service and only covers 10 States.
              </div>
            </span>
            <span className="col-sm-6">
              <div className="padit align-items-center justify-content-center border border-info botshdr">
                States: Connecticut,
                Florida,
                Georgia,
                New Jersey,
                New York,
                North Carolina,
                Pennsylvania,
                South Carolina,
                Tennessee,
                Texas

              </div>
            </span>
          </div>
        </Form>
      </div>

    </div>
  )
}

export default Where;
